import { render } from "./titleBlock.vue?vue&type=template&id=48104edd&ts=true"
import script from "./titleBlock.vue?vue&type=script&lang=ts"
export * from "./titleBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__